import { useMemo, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const CronWeekDayButton = ({ id, text, selected, onClick }) => {
    const handleClick = () => onClick?.(id);

    return <button className={'btn btn-input' + (selected ? ' selected' : '')} onClick={handleClick}>{text}</button>;
}

const DayOfWeekSelector = ({ value, multi, onChange }) => {
    const { t } = useTranslation('recurring');

    const options = useMemo(() => [
        {
            id: 2,
            text: t('date:weekDays_short.Monday')
        },
        {
            id: 3,
            text: t('date:weekDays_short.Tuesday')
        },
        {
            id: 4,
            text: t('date:weekDays_short.Wednesday')
        },
        {
            id: 5,
            text: t('date:weekDays_short.Thursday')
        },
        {
            id: 6,
            text: t('date:weekDays_short.Friday')
        },
        {
            id: 7,
            text: t('date:weekDays_short.Saturday')
        },
        {
            id: 1,
            text: t('date:weekDays_short.Sunday')
        }
    ], [t]);

    const handleClick = day => {
        if (multi) {
            if (value.dayOfWeek.indexOf(day) >= 0) {
                onChange(value.dayOfWeek.filter(d => d !== day));
            } else {
                onChange([...value.dayOfWeek, day].sort());
            }
        } else {
            onChange([day]);
        }
    }

    useEffect(() => {
        if (!value.dayOfWeek?.length) {
            onChange([2]);
        }
    }, [value, onChange]);

    return (
        <div className="resource-repeat-row">
            <div className="row-label">
                { t('On (week day)') }
            </div>

            <div className="row-value">
                <div className="row-input">
                    <div className="row-input-button-group">
                        {
                            options.map(day => <CronWeekDayButton
                                key={day.id}
                                id={day.id}
                                text={day.text}
                                selected={value.dayOfWeek?.includes(day.id)}
                                onClick={handleClick}
                            />)
                        }
                    </div>
                </div>
            </div>
        </div>
    );
}

export default DayOfWeekSelector;
